import React from "react";
import { Button } from "@/components/ui/Button";
import {
  Users,
  LayoutGrid,
  Store,
  Tags,
  Settings,
  ShoppingBag,
  LogOut,
  Printer,
  Calculator,
} from "lucide-react";

import {DateTimeDisplay} from "../utils/DateTimeDisplay"

const Sidebar = ({
  isMobile,
  isSidebarOpen,
  currentView,
  setIsSidebarOpen,
  setCurrentView,
  onLogout,
}) => {
  const menuItems = [
    { view: "camarero", icon: Users, text: "Modo Camarero" },
    { view: "mesas", icon: LayoutGrid, text: "Mesas" },
    { view: "mostrarMesas", icon: Store, text: "Mostrar Mesas" },
    { view: "categorias", icon: Tags, text: "Categorías" },
    { view: "admCategorias", icon: Settings, text: "Adm. Categorías" },
    { view: "productos", icon: ShoppingBag, text: "Productos" },
    { view: "admProductos", icon: Settings, text: "Adm. Productos" },
    // { view: "barra", icon: Wine, text: "Barra" },
    // { view: "cocina", icon: ChefHat, text: "Cocina" },
    // { view: "historico", icon: History, text: "Histórico" },
    // {
    //   view: "configuracion",
    //   icon: Printer,
    //   text: "Configuración (1)",
    //   description: "Configuración de impresora única",
    // },
    {
      view: "configuracionMultiplesImpresoras",
      icon: Printer,
      text: "Configuración Múltiple",
      description: "Configuración de múltiples impresoras",
    },
    {
      view: "arqueo",
      icon: Calculator,
      text: "Arqueo del Día",
      description: "Reporte diario de ventas",
    },
  ];

  return (
    <aside
      className={`
        fixed top-0 left-0 h-screen bg-white shadow-lg 
        transform transition-transform duration-200 ease-in-out 
        ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
        ${isMobile ? "w-full md:w-64" : "w-64"}
        z-20
      `}
    >
      <div className="p-4 border-b flex justify-between items-center bg-orange-500">
        <h2 className="text-xl font-bold text-white">Tataoul</h2>
        {isMobile && (
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsSidebarOpen(false)}
            className="text-white hover:bg-orange-600"
          >
            <X className="h-5 w-5" />
          </Button>
        )}
      </div>

      <nav className="p-4">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.view}>
              <Button
                variant="ghost"
                className={`w-full flex flex-row-reverse justify-between hover:bg-orange-100
                  ${
                    currentView === item.view
                      ? "bg-orange-100 text-orange-600"
                      : ""
                  }`}
                onClick={() => {
                  setCurrentView(item.view);
                  if (isMobile) setIsSidebarOpen(false);
                }}
              >
                <item.icon className="h-4 w-4" />
                {item.text}
              </Button>
            </li>
          ))}
          <li>
            <Button
              variant="ghost"
              className="w-full flex flex-row-reverse text-red-600 hover:bg-red-50"
              onClick={onLogout}
            >
              <LogOut className="ml-2 h-4 w-4" />
              Cerrar Sesión  
              {/* Formato compacto */}
       
            </Button>
             <div>
          
          <DateTimeDisplay format="compact" />
        </div>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
